// ── Mobile Nav ──
function toggleMobileNav() {
  document.querySelector('.mobile-nav-btn').classList.toggle('active');
  document.querySelector('.mobile-nav-overlay').classList.toggle('active');
  document.querySelector('.mobile-nav-panel').classList.toggle('active');
  document.body.style.overflow = document.querySelector('.mobile-nav-panel').classList.contains('active') ? 'hidden' : '';
}

// ── Cart Drawer ──
function toggleCartDrawer() {
  document.querySelector('.cart-drawer-overlay').classList.toggle('active');
  document.querySelector('.cart-drawer').classList.toggle('active');
  document.body.style.overflow = document.querySelector('.cart-drawer').classList.contains('active') ? 'hidden' : '';
}

// ── Cart Page Item Update ──
function updateCartPageItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(() => { window.location.reload(); })
  .catch(err => console.error('Cart update failed:', err));
}

// ── Cart Drawer Item Update ──
function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(cart => { renderCartDrawer(cart); })
  .catch(err => console.error('Cart update failed:', err));
}

function renderCartDrawer(cart) {
  var body = document.querySelector('.cart-drawer-body');
  var footer = document.querySelector('.cart-drawer-footer');
  var cartBtn = document.querySelector('.cart-text');

  if (cartBtn) cartBtn.textContent = 'Cart (' + cart.item_count + ')';

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p>Your cart is empty</p></div>';
    footer.innerHTML = '<button onclick="toggleCartDrawer()">Continue Shopping</button>';
    return;
  }

  var html = '';
  cart.items.forEach(function(item) {
    var titleParts = item.product_title.split(' – ');
    var displayTitle = titleParts[0];
    var variantTitle = item.variant_title || '';
    var imgTag = item.image ? '<img src="' + getSizedImageUrl(item.image, '80x80') + '" alt="' + displayTitle.replace(/"/g, '&quot;') + '" width="80" height="80">' : '';
    var price = formatMoney(item.final_line_price);

    html += '<div class="cart-item" data-cart-item-key="' + item.key + '">';
    html += imgTag;
    html += '<div class="cart-item-details">';
    html += '<a href="' + item.url + '">' + displayTitle + '</a>';
    if (variantTitle && variantTitle !== 'Default Title') {
      html += '<span>' + variantTitle + '</span>';
    }
    html += '<div class="cart-item-bottom">';
    html += '<div class="cart-item-qty">';
    html += '<button class="cart-qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease quantity">\u2212</button>';
    html += '<span class="cart-qty-num">' + item.quantity + '</span>';
    html += '<button class="cart-qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>';
    html += '</div>';
    html += '<span class="cart-item-price">' + price + '</span>';
    html += '<button class="cart-item-remove" onclick="updateCartItem(\'' + item.key + '\', 0)" aria-label="Remove item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
    html += '</div></div></div>';
  });

  body.innerHTML = html;

  var totalPrice = formatMoney(cart.total_price);
  footer.innerHTML = '<div style="display:flex;justify-content:space-between;margin-bottom:12px;font-weight:600;"><span>Subtotal</span><span>' + totalPrice + ' CAD</span></div><a href="/checkout" style="display:block;text-align:center;background:var(--sun-orange);color:#fff;padding:14px;border-radius:var(--radius-sm);font-family:\'Oswald\',sans-serif;font-weight:600;text-transform:uppercase;letter-spacing:1px;text-decoration:none;">Checkout</a>';
}

function getSizedImageUrl(url, size) {
  if (!url) return '';
  var match = url.match(/(.+)\.(jpg|jpeg|png|gif|webp)/i);
  if (match) return match[1] + '_' + size + '.' + match[2];
  return url;
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ── Quantity ──
function updateQty(btn, delta) {
  const row = btn.closest('.qty-row');
  const input = row.querySelector('.qty-value');
  const atcBtn = row.querySelector('.add-to-cart');
  let v = parseInt(input.value) + delta;
  if (v < 1) v = 1;
  if (v > 10) v = 10;
  input.value = v;
  if (atcBtn && atcBtn.dataset.price) {
    const price = parseFloat(atcBtn.dataset.price);
    atcBtn.textContent = 'Add to Cart — $' + (price * v).toFixed(2);
  }
}

// ── Tabs & FAQs ──
function initTabsAndFaqs() {
  // Tabs
  document.querySelectorAll('.section-tab').forEach(tab => {
    tab.onclick = function() {
      const parent = this.closest('.content-sections');
      parent.querySelectorAll('.section-tab').forEach(t => t.classList.remove('active'));
      parent.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      document.getElementById('tab-' + this.dataset.tab).classList.add('active');
    };
  });

  // FAQs
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.onclick = function() {
      const item = this.parentElement;
      const list = item.closest('.faq-list');
      const wasOpen = item.classList.contains('open');
      list.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    };
  });

  // Thumbnails
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.onclick = function() {
      const row = this.closest('.thumb-row');
      row.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      // Update main image
      const img = this.querySelector('img');
      if (img) {
        const mainImg = this.closest('.product-gallery').querySelector('.main-image img');
        if (mainImg) {
          mainImg.src = img.src.replace('width=120', 'width=800');
        }
      }
    };
  });
}

// ── Colour Swatches ──
document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.colour-swatch');
  if (!swatch) return;
  const selector = swatch.closest('.colour-selector');
  selector.querySelectorAll('.colour-swatch').forEach(s => s.classList.remove('active'));
  swatch.classList.add('active');
  selector.querySelector('.selected-colour').textContent = swatch.dataset.colour;

  // Update sticky ATC variant name
  const stickyVariant = document.getElementById('sticky-variant-name');
  if (stickyVariant) stickyVariant.textContent = swatch.dataset.colour;

  // Update variant ID for Shopify cart
  const variantId = swatch.dataset.variantId;
  if (variantId) {
    const hiddenInput = document.getElementById('product-variant-id');
    if (hiddenInput) hiddenInput.value = variantId;
  }

  // Update main image to show the selected variant's image
  const variantImageUrl = swatch.dataset.variantImage;
  if (variantImageUrl) {
    const gallery = swatch.closest('section');
    if (gallery) {
      const mainImg = gallery.querySelector('.main-image img');
      if (mainImg) {
        mainImg.src = variantImageUrl;
      }
      // Also highlight the matching thumbnail if one exists
      const variantBase = variantImageUrl.split('?')[0];
      const thumbs = gallery.querySelectorAll('.thumb');
      let matched = false;
      thumbs.forEach(t => {
        t.classList.remove('active');
        const tImg = t.querySelector('img');
        if (tImg) {
          const thumbBase = tImg.src.split('?')[0];
          if (variantBase === thumbBase) {
            t.classList.add('active');
            matched = true;
          }
        }
      });
      if (!matched && thumbs[0]) thumbs[0].classList.add('active');
    }
  }
});

// ── Sorting ──
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.sort-btn');
  if (!btn) return;

  const sortType = btn.dataset.sort;
  const controls = btn.closest('.sort-controls');
  controls.querySelectorAll('.sort-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  // Find the nearest product-grid sibling
  let grid = null;
  let parent = controls.closest('.cat-section');
  if (parent) {
    grid = parent.querySelector('.sortable-grid') || parent.nextElementSibling;
    while (grid && !grid.classList.contains('product-grid') && !grid.classList.contains('sortable-grid')) {
      grid = grid.nextElementSibling;
    }
  }
  // Fallback: look for .sortable-grid on the page
  if (!grid) {
    grid = document.querySelector('.sortable-grid, .product-grid');
  }
  if (!grid) return;

  const cards = [...grid.querySelectorAll('.product-card')];

  cards.sort((a, b) => {
    if (sortType === 'price-low') {
      return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
    } else if (sortType === 'price-high') {
      return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
    } else if (sortType === 'on-sale' || sortType === 'newest') {
      return parseInt(b.dataset.sale || 0) - parseInt(a.dataset.sale || 0);
    } else {
      return parseInt(a.dataset.order) - parseInt(b.dataset.order);
    }
  });

  cards.forEach(card => grid.appendChild(card));
});

// Cart toast notification
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('add-to-cart') || e.target.classList.contains('sticky-atc-btn')) {
    const toast = document.getElementById('cart-toast');
    if (toast) {
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 2000);
    }
  }
});

// ── Sticky ATC on mobile ──
(function() {
  const ann = document.querySelector('.announcement-bar');

  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;

    // Auto-hide announcement bar on scroll down, show on scroll up
    if (ann) {
      if (scrollY > 80) {
        ann.classList.add('hidden');
      } else {
        ann.classList.remove('hidden');
      }
    }

    // Back to top button
    const btt = document.getElementById('backToTop');
    if (btt) {
      if (scrollY > 600) { btt.classList.add('visible'); }
      else { btt.classList.remove('visible'); }
    }

    // Sticky ATC: show when the real ATC button scrolls out of view
    const stickyBar = document.querySelector('.sticky-atc');
    const realAtc = document.querySelector('.atc-section');
    if (!stickyBar || !realAtc) return;

    const rect = realAtc.getBoundingClientRect();
    if (rect.bottom < 0) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  }, { passive: true });
})();

// ── Init on page load ──
document.addEventListener('DOMContentLoaded', function() {
  initTabsAndFaqs();
});
